import getHostVariables from './getHostVariables';
import {ROOT_NODE} from '../symbols';

export default function applyIntersectStyles(el, config, options) {
	const {width, height} = options;

	if (!width && !height) return;

	const hostVariables = getHostVariables(el);
	const rootNode = hostVariables[ROOT_NODE];

	const styles = `:host {${width ? `width: ${width};` : ''}${height ? `height: ${height};` : ''}}`;

	return applyWithTag(rootNode, styles);
}

function applyWithTag(rootNode, styles) {
	const styleElement = window.document.createElement('style');
	styleElement.type = 'text/css';
	styleElement.innerHTML = styles;
	rootNode.appendChild(styleElement);

	return () => {
		if (styleElement.parentNode === rootNode) {
			rootNode.removeChild(styleElement);
		}
	};
}
